import { isEmpty } from 'lodash-es';
import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { autocompleteClientRecruiterName, ClientContactDTO } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import { fetchNameAndEmailFromClientContact } from '../../features/jobs/helper';
import { useClientAuthz, ClientAction } from '../../hooks/useClientAuthz';

interface IClientAutoCompleteFilter {
  name: string;
  showMandatorySymbol?: boolean;
  clientContactIdFieldName?: string;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  clientId: string;
  clientName?: string;
  onNewValueCreate?: (data: string) => void;
  textForAddingNew?: string;
  component?: string;
  hideLabel?: boolean;
}
const ClientContactAutoComplete = ({
  name,
  showMandatorySymbol = false,
  clientContactIdFieldName,
  placeholder = 'Eg: Alice',
  label = 'Client Recruiter',
  disabled = false,
  clientId,
  onNewValueCreate,
  textForAddingNew,
  component,
  hideLabel = false,
}: IClientAutoCompleteFilter) => {
  const clientContactList = useRef<ClientContactDTO[]>([]);

  const { setValue } = useFormContext();
  const isAddClientContactAuthorized = useClientAuthz(ClientAction.ADD_VIEW_USER_CONTACT_DETAILS);

  const onChange = (event) => {
    const data = event.includes('|') ? event.split('|')[0] : event;
    const fetchedEmail = data?.split(' - ')[1]?.trim();

    const foundClient = clientContactList.current?.filter(
      (client) => client.emailAddress === fetchedEmail
    );
    setValue(name, fetchedEmail);
    if (clientContactIdFieldName && !isEmpty(foundClient))
      setValue(clientContactIdFieldName, foundClient[0]?.id);
    setValue(
      'clientRecruiterName',
      `${foundClient[0]?.firstName} ${foundClient[0]?.lastName ?? ''}`
    );
  };

  const onClientContactInputKey = async (client: string) => {
    const result = await autocompleteClientRecruiterName(
      `${encodeURIComponent(
        client
          .trim()
          .split(' ')
          .map((clientContact) => clientContact.replaceAll(' ', '') + ':*')
          .join(' & ')
      )}`,
      clientId
    );

    if (result?.data.length > 0) {
      clientContactList.current = result.data;
      return fetchNameAndEmailFromClientContact(result.data) ?? [];
    }
    return [];
  };

  return (
    <>
      {isAddClientContactAuthorized || component === 'job' ? (
        <WsAutocompleteInput
          {...(!hideLabel && { label })}
          name={name}
          key={name}
          options={[]}
          placeholder={placeholder}
          getOptions={onClientContactInputKey}
          showMandatorySymbol={showMandatorySymbol}
          disable={disabled}
          textForAddingNew={textForAddingNew}
          onNewValueCreate={onNewValueCreate}
          onChange={onChange}
          disableAddNewOption={isAddClientContactAuthorized && textForAddingNew}
        />
      ) : (
        <WsAutocompleteInput
          label={label}
          name={name}
          key={name}
          options={[]}
          placeholder={placeholder}
          getOptions={onClientContactInputKey}
          showMandatorySymbol={showMandatorySymbol}
          disable={disabled}
          onChange={onChange}
        />
      )}
    </>
  );
};

export default ClientContactAutoComplete;
